import { render } from "./PageUnauthorized401.vue?vue&type=template&id=6f3b0ba9"
import script from "./PageUnauthorized401.vue?vue&type=script&lang=js"
export * from "./PageUnauthorized401.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__